<!-- lab-hand-crafted -->
@if (visible$()) {
  <div
    data-shortcut-layer="modal"
    class="lab-dialogs-container"
    [class.lab-dialogs-container-fade-in]="visibility$() === 'fadingIn'"
    [class.lab-dialogs-container-fade-out]="visibility$() === 'fadingOut'"
  >
    @for (entry of entries$(); track entry.id; let index = $index) {
      <div class="lab-dialog-container" role="dialog" [cdkTrapFocus]="index === entries$().length - 1">
        <!-- lab-dialog-container creates the dynamic dialog body; lab-dialogs owns stacking/backdrop only. -->
        <lab-dialog-container [entry]="entry" />
      </div>
    }
  </div>
}
